import { httpClient } from '@/services/http/httpClient'

export async function deleteAllIdeaFieldTemplates(): Promise<void> {
  await httpClient.delete('/ideas/campaigns/field-templates/all')
}
